import { CheckCircle, FileCopyOutlined } from "@mui/icons-material";
import {
  Avatar,
  Box,
  Container,
  IconButton,
  List,
  ListDivider,
  ListItem,
  ListItemContent,
  Snackbar,
  Stack,
  Typography,
} from "@mui/joy";
import * as React from "react";
import CopyToClipboard from "react-copy-to-clipboard";
import { useLocation } from "react-router";
import { HeaderBackButtonHome } from "../components/HeaderBackButton";
import { CryptoCurrencyFormat, CurrencyFormat } from "../config/services";

let today = new Date();
const dd = String(today.getDate()).padStart(2, "0");
const mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
const yyyy = today.getFullYear();
const time = today.getHours() + ":" + today.getMinutes();

export default function Success() {
  let { state } = useLocation();

  let { recipient, amount, pending, cointitle, coin } = state;

  const [open, setOpen] = React.useState(false);

  const handleClose = () => setOpen(false);

  const truncateAddress = (address = "", start = 6, end = 6) => {
    if (!address) return "";
    if (address.length <= start + end + 3) return address;
    return `${address.slice(0, start)}...${address.slice(-end)}`;
  };

  const formattedRecipient = truncateAddress(recipient);

  return (
    <>
      <HeaderBackButtonHome title={`Sent ${cointitle}`} />
      <Container maxWidth="sm">
        <Stack spacing={4}>
          <Box display={"flex"} justifyContent={"center"}>
            <Stack spacing={1} alignItems={"center"}>
              <Typography level="title-lg" color="primary">
                + <CryptoCurrencyFormat amount={coin} suffix={""} /> {cointitle}
              </Typography>
              <Typography level="body-sm">
                <CurrencyFormat amount={amount} prefix={"$"} seperator={true} />
              </Typography>
              <Stack spacing={1} direction={"row"}>
                <Typography level="body-sm">Completed</Typography>
                <Avatar variant="outlined" size="xsm">
                  <CheckCircle fontSize="small" color="success" />
                </Avatar>
              </Stack>
            </Stack>
          </Box>

          <List variant="outlined" sx={{ borderRadius: 10 }}>
            <ListItem>
              <ListItemContent>Status</ListItemContent>
              <Typography
                level="body-sm"
                color={pending ? "warning" : "success"}
              >
                {pending ? "Pending" : "Completed"}
              </Typography>
            </ListItem>
            <ListDivider />
            <ListItem>
              <ListItemContent>Date</ListItemContent>
              <Typography level="title-sm">{`${mm}/${dd}/${yyyy} ${time}`}</Typography>
            </ListItem>
            <ListDivider />
            <ListItem>
              <ListItemContent>Recipient</ListItemContent>
              <Stack
                direction="row"
                spacing={1}
                alignItems="center"
                justifyContent="flex-end"
                width="50%"
              >
                <Typography level="title-sm" textAlign="right" noWrap>
                  {formattedRecipient}
                </Typography>
                <CopyToClipboard
                  text={recipient}
                  onCopy={() => setOpen(true)}
                >
                  <IconButton size="sm" variant="outlined">
                    <FileCopyOutlined fontSize="small" />
                  </IconButton>
                </CopyToClipboard>
              </Stack>
            </ListItem>
          </List>
        </Stack>
      </Container>
      <Snackbar
        color="success"
        size="md"
        variant="soft"
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        open={open}
        onClose={handleClose}
      >
        Address copied
      </Snackbar>
    </>
  );
}
